export const environment = {
    production: true,
    api_url: "https://dooh-api.staging.theneuron.com",
    default_local_url: "smb.staging.theneuron.com",
    VERSION: "1.4.0",
    hyperPayUrl: 'https://test.oppwa.com/v1/paymentWidgets.js?checkoutId=',
    isProd: false,
    defaultNamespaceId: '9c1d1e2f-152e-4f35-84a4-ae1deb490b01',
    mapbox: {
      accessToken: 'pk.eyJ1IjoidG5hZG1pbmRldiIsImEiOiJjbDhjdXR4bWUwM3cyM3FuenptcjNtOXEwIn0.3-n9cFilRsStqog6AK6s1g',
      style_light: 'mapbox://styles/tnadmindev/clcrh3nws006r14t9f5o50bap',
      style_dark: 'mapbox://styles/tnadmindev/clpm9uwdg00uc01qt9yzdecgq'
    },
    AVUXI_USER_ID:'f246c5c7-43c8-4ccf-ba57-b318c02e8740',
    userpilotToken: '84li88m7',
    uploading: 'https://studio-api.staging.theneuron.com/studio/api/uploads/assets',
    api: 'https://studio-api.staging.theneuron.com/studio/api/',
    assetsS3: 'https://dxz7xvhrcq01u.cloudfront.net/',
    creativesS3: 'https://do8bykvwd8chd.cloudfront.net/',
    hotjarSiteId: null,
  };